import React, { useContext } from 'react'

import { Filters } from '../../types/general'
import useFilters from '../hooks/useFilters'

export interface FiltersContextInterface {
  filters: Filters
  setFilter: (filter: Filters) => void
}

export const filtersContext = React.createContext<FiltersContextInterface | undefined>(undefined)

const { Provider } = filtersContext

export function useFiltersContext(): FiltersContextInterface {
  const contextValue = useContext(filtersContext)
  if (contextValue === undefined) {
    throw new Error('Context must be inside a Provider')
  }
  return contextValue
}

interface ProviderProps {
  children: React.ReactNode
}

const FiltersProvider: React.FC<{ children: React.ReactNode }> = ({ children }: ProviderProps) => {
  const filterAcessors = useFilters()
  return <Provider value={filterAcessors}>{children}</Provider>
}

export default FiltersProvider
